import app from "flarum/forum/app";
import Notification from "flarum/forum/components/Notification";
/**
 * "X declined your invitation to #channel."
 *
 * Sent to the channel's owner and to whoever invited, so a refusal is an answer
 * rather than an invitation that quietly stopped being pending. Clicking opens
 * the channel: the next thing to do about it, if anything, is invite somebody
 * else from its members tab.
 */
export default class ChannelInviteDeclinedNotification extends Notification {
  icon() {
    return "fas fa-user-xmark";
  }
  href() {
    const channelId = this.data().channelId;
    return channelId ? app.route("chat.channel", {
      id: channelId
    }) : app.route("chat.index");
  }
  content() {
    var _this$data$channelNam;
    const decliner = this.attrs.notification.fromUser();
    return app.translator.trans("ramon-chat.forum.notifications.channel_invite_declined", {
      username: decliner ? decliner.displayName() : app.translator.trans("ramon-chat.forum.notifications.someone", {}, true),
      channel: (_this$data$channelNam = this.data().channelName) != null ? _this$data$channelNam : app.translator.trans("ramon-chat.forum.nav.chat", {}, true)
    });
  }
  excerpt() {
    return null;
  }
  data() {
    var _ref;
    return (_ref = this.attrs.notification.content()) != null ? _ref : {};
  }
}
flarum.reg.add('ramon-chat', 'forum/components/ChannelInviteDeclinedNotification', ChannelInviteDeclinedNotification);